export class DateHelper{

  public static GetFormattedDate(date:Date):string{

    if (date.getFullYear().toString() == '0001' || date.getFullYear().toString() =='1') {
      return '';
    }

    //get date in following format: 31.12.2020
    return `${date.getDate()}.${date.getMonth()}.${date.getFullYear()}`;
  }
}
